import $ from 'jquery';
import { displayPhotoInfo } from './displayPhotoInfo';

export const onClickPhotoInfo = (event) => {
  const sidebarCurrentPhotoItemId = $(event.currentTarget).data(
    'photo-item-id'
  );
  displayPhotoInfo(sidebarCurrentPhotoItemId);
};
